import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  createItemMultiple,
} from "./accurateAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "accurate/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("accurate/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "accurate/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("accurate/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const addItemMultiple = createAsyncThunk(
  "accurate/addItemMultiple",
  async (payload) => {
    const response = await createItemMultiple(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "accurate/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "accurate/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const accurateSlice = createSlice({
  name: "accurate",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })

      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addItemMultiple.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItemMultiple.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = accurateSlice.actions;

export const selectData = (state) => state.accurate.data;
export const selectCrashReport = (state) => state.accurate.data;
export const selectId = (state) => state.accurate.dataId;
export const selectLoading = (state) => state.accurate.loading;
export const selectError = (state) => state.accurate.error;
export const selectPageNo = (state) => state.accurate.pageNo;
export const selectPageSize = (state) => state.accurate.pageSize;
export const selectTotalRecord = (state) => state.accurate.totalRecord;
export const selectSelected = (state) => state.accurate.selected;
export const selectResult = (state) => state.accurate.result;

export default accurateSlice.reducer;
